/**
 * Toaster — shadcn-style Sonner wrapper with Xyden brand styling.
 *
 * Mount once in App.tsx: <Toaster />
 * Trigger from anywhere: showToast({ variant, title, description })
 */

import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      expand={false}
      richColors={false}
      duration={5000}
      closeButton={false}
      toastOptions={{
        className: "!p-0 !bg-transparent !border-none !shadow-none",
      }}
    />
  );
}
